/* eslint react/no-array-index-key: 0 */
// react
import React from "react";

// styles
import css from "../Table.module.scss";

type TableLoadingProps = {
	columnWidths: string;
	rows?: number;
	cols?: number;
	scrollable?: boolean;
};

const TableLoading = ({ columnWidths, rows = 10, cols = 5, scrollable = false }: TableLoadingProps) => {
	return (
		<div className={css.tableLoader} data-testid="table-loading">
			{Array.from({ length: rows }).map((d, ii) => {
				const colArray = Array.from({ length: cols });
				const gridTemplateColumns = columnWidths;

				return (
					<div
						key={ii}
						className={`${css.loadingRow} ${scrollable && css.scrollableRow}`}
						style={{ gridTemplateColumns }}
					>
						{colArray.map((dd, jj) => (
							<div key={jj} className={css.loadingCell} />
						))}
					</div>
				);
			})}
		</div>
	);
};

export default TableLoading;
